/**
 * Wrapper for the Node.js implementation of the HTTP(S) request function.
 *
 * In the future this module could conditionally provide VST support.
 *
 * @packageDocumentation
 * @internal
 * @hidden
 */

export * from "./request.node";
